import { render, staticRenderFns } from "./NotFoundScanCount.vue?vue&type=template&id=986d88a0&scoped=true&"
import script from "./NotFoundScanCount.vue?vue&type=script&lang=js&"
export * from "./NotFoundScanCount.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "986d88a0",
  null
  
)

export default component.exports